"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.absoluteMajor0DP = exports.absoluteMajor2DP = exports.minor2DP = exports.major4DP = exports.smartMajor2DP = exports.major2DP = exports.major0DP = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var config_1 = require("../config");
var withCurrencyCode = function (func) { return function (amount, code) {
    var retailer = config_1.configService.getConfig().retailer;
    if (code) {
        return func(amount, code);
    }
    else if (retailer && retailer.currencyCode) {
        return func(amount, retailer.currencyCode);
    }
    return '';
}; };
var major0DP = withCurrencyCode(ui_tools_1.major0DP);
exports.major0DP = major0DP;
var major2DP = withCurrencyCode(ui_tools_1.major2DP);
exports.major2DP = major2DP;
var smartMajor2DP = withCurrencyCode(ui_tools_1.smartMajor2DP);
exports.smartMajor2DP = smartMajor2DP;
var major4DP = withCurrencyCode(ui_tools_1.major4DP);
exports.major4DP = major4DP;
var minor2DP = withCurrencyCode(ui_tools_1.minor2DP);
exports.minor2DP = minor2DP;
var absoluteMajor2DP = function (amount) {
    var parsedAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    return major2DP(Math.abs(parsedAmount));
};
exports.absoluteMajor2DP = absoluteMajor2DP;
var absoluteMajor0DP = function (amount) {
    var parsedAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    return major0DP(Math.abs(parsedAmount));
};
exports.absoluteMajor0DP = absoluteMajor0DP;
